import React from 'react';
import { Card } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import PageWrapper from '../../../PageWrapper/PageWrapper';
import ServiceFee from '../../ServiceFee/ServiceFee';
import ChangeHeader from './ChangeHeader';
import AssetsTable from '../../AssetsTable/AssetsTable';
import TaxImplications from './TaxImplications';
import RecommendedPortfolioTable from '../../RecommendedPortfolioTable/RecommendedPortfolioTable';
import IPDocCard from '../../../IPDocCard/IPDocCard';

import './ChangeHub.scss';

const AccountChangeHub = ({
    clientDetails,
    agreementsGroupByType,
    externalAccounts,
    modelAssetAllocationAssociatedFund,
    previousModelAssetAllocationAssociatedFund,
    hasAccounts,
    modelChange,
    requiresRASU,
    noPartnerActivateNeeded,
    assetsAsOfDate,
    isInternal,
    monthlyFee,
    dedicatedTotal,
    hasInternalAccounts,
    hasExternalAccounts,
    hasIneligibleExternalAccounts,
    hasIneligibleBrokerage
}) =>
    <>
        <PageWrapper>
            <ChangeHeader
                header='Submit your changes'
                hasAccounts={hasAccounts}
                requiresRASU={requiresRASU}
                noPartnerActivateNeeded={noPartnerActivateNeeded}
                isInternal={isInternal}
                hasInternalAccounts={hasInternalAccounts}
                hasExternalAccounts={hasExternalAccounts}
                hasIneligibleExternalAccounts={hasIneligibleExternalAccounts}
                hasIneligibleBrokerage={hasIneligibleBrokerage}
                modelChange={modelChange}
            />
            {isInternal &&
                <div style={{ marginTop: '32px' }}>
                    <IPDocCard />
                </div>
            }
        </PageWrapper>
        <PageWrapper>
            <div className='changeDisplayContainer'>
                <div className='changeDisplaySection'>
                    <Card id='recc-port-card1' className='modelChangeCard'>
                        <div className='hub-header-container'>
                            <div
                                className='hubProposalHeader'
                                id='recc-model-title'
                            >
                                Accounts to Fund the Service
                            </div>
                            <p
                                style={{ fontFamily: 'Nimbus Sans Reg' }}
                                id='recc-model-copy'
                            >
                                The current eligible accounts you identified to be enrolled and transferred into the Service are listed below.
                                If you have chosen to transfer any brokerage accounts into the Service, all of their underlying holdings will be included.
                            </p>
                            <p
                                className='hubPropAod'
                                id='pti-as-of-date'
                            >
                                Proposal generated as of {assetsAsOfDate} and balances are generally as of the prior business day&apos;s close
                            </p>
                        </div>
                        <AssetsTable
                            agreementsGroupByType={agreementsGroupByType}
                            externalAccounts={externalAccounts}
                            clientDetails={clientDetails}
                        />
                    </Card>
                    {useMediaQuery('(min-width:1166px)') && <TaxImplications agreementsGroupByType={agreementsGroupByType} assetsAsOfDate={assetsAsOfDate} />}
                </div>

                <div className='changeDisplaySection'>
                    <Card id='recc-port-card2' className='modelChangeCard'>
                        <div className='hub-header-container'>
                            <div
                                className='hubProposalHeader'
                                id='recc-model-title'
                            >
                                {`Recommended ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio`}
                            </div>
                            <p
                                style={{ fontFamily: 'Nimbus Sans Reg' }}
                                id='recc-model-copy'
                            >
                                {modelChange ?
                                    `We previously recommended the ${previousModelAssetAllocationAssociatedFund.modelInformation.name} Portfolio. Based on your updated responses
                                    to the investment time horizon and risk tolerance questions in our Service questionnaire and other planning considerations, we now recommend
                                    the ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio.`
                                    :
                                    `We continue to recommend the ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio based on your updated responses to the
                                    investment time horizon and risk tolerance questions in our Service questionnaire and other planning considerations.`
                                }
                            </p>
                        </div>
                        <RecommendedPortfolioTable
                            modelAssetAllocationAssociatedFund={modelAssetAllocationAssociatedFund}
                            total={dedicatedTotal}
                        />
                    </Card>
                    <div style={{ paddingTop: '32px' }} id='service-fee-rj'>
                        <ServiceFee
                            total={dedicatedTotal}
                            fee={monthlyFee}
                        />
                    </div>
                    {!useMediaQuery('(min-width:1166px)') && <TaxImplications agreementsGroupByType={agreementsGroupByType} assetsAsOfDate={assetsAsOfDate} />}
                </div>
            </div>
        </PageWrapper>
    </>;

export default AccountChangeHub;
